import { formatExportRequestCount } from './format-export-request-count.js';

export function buildSelectionExportConfirmMessage(
  selectedRowCount: number,
  totalCount: number,
): string {
  const selectedRows = `${selectedRowCount.toLocaleString()} selected ${selectedRowCount === 1 ? 'row' : 'rows'}`;
  return `Finding your ${selectedRows} means scanning all ${totalCount.toLocaleString()} rows, which takes ${formatExportRequestCount(totalCount)} requests and may take a while. Export anyway?`;
}
